import { Logo } from "./Logo";
import { NAV, CONTACT } from "../../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0d1110] text-white/70">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-3 md:px-10">
      <div>
        <Logo light />
        <p className="mt-6 max-w-xs text-sm">Civil works for forests, wildlife and water across Karnataka since 2018.</p>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-wider text-white/40">Quick links</p>
        <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
          {NAV.map((n) => <li key={n.id}><a href={`/#${n.id}`} data-testid={`footer-${n.id}-link`} className="transition-colors hover:text-white">{n.label}</a></li>)}
          <li><a href="/#registrations" data-testid="footer-registrations-link" className="transition-colors hover:text-white">Registrations</a></li>
        </ul>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-mono text-xs uppercase tracking-wider text-white/40">Contact</p>
        <a href={CONTACT.phoneTel} data-testid="footer-phone-link" className="block pt-2 hover:text-white">{CONTACT.phoneDisplay}</a>
        <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="block hover:text-white">{CONTACT.email}</a>
        <p>{CONTACT.address}</p>
        <a href="/vata-infrastructures-company-profile.pdf" download data-testid="footer-brochure-link" className="block pt-2 font-semibold text-white hover:text-[var(--rust-light)]">Company profile (PDF)</a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-6 font-mono text-xs md:flex-row md:px-10">
        <span data-testid="footer-registered-name">© {new Date().getFullYear()} Vata Infrastructures (Proprietor: Darshan Bhaskar T), Bengaluru</span>
        <span>GSTIN 29BQOPD4358M1Z6</span>
      </div>
    </div>
  </footer>
);
